var map = {
	"./clinic/clinic-dashboard.vue": 15,
	"./clinic/clinic-definitions.vue": 9971,
	"./clinic/clinic-doctors.vue": 1706,
	"./clinic/clinic-invoice.vue": 6856,
	"./clinic/clinic-patients.vue": 1605,
	"./clinic/clinic-reception.vue": 5923,
	"./clinic/clinic-receptionlist.vue": 8055,
	"./clinic/clinic-reports.vue": 5539,
	"./clinic/clinic-services.vue": 7707,
	"./clinic/clinic-store.vue": 6543,
	"./clinic/clinic-users.vue": 1527,
	"./common/CompanySetup.vue": 8440,
	"./common/LoginPage.vue": 4202,
	"./common/LoginPage3.vue": 1003,
	"./common/app-settings.vue": 8165,
	"./common/notifications-center.vue": 8883,
	"./common/paid-invoices.vue": 5603,
	"./common/paymentResult.vue": 5091,
	"./common/user-area.vue": 2669,
	"./official/CrmPage.vue": 4368,
	"./official/HozoGhiab.vue": 5649,
	"./official/PeyghamSaz.vue": 784,
	"./official/SoroushPage.vue": 8510,
	"./official/archivePage.vue": 6196,
	"./official/secretariatPage.vue": 7334,
	"./print-check/accounts-side.vue": 7289,
	"./print-check/bank-accounts.vue": 5858,
	"./print-check/checks-cat.vue": 9701,
	"./print-check/record-check.vue": 6185
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7591;